<app-nav-bar></app-nav-bar>

<div class="my-account-container">
    <!-- Account Header -->
    <div class="account-header">
        <div class="header-content">
            <h1 class="account-title">
                <fa-icon [icon]="icons.faUser" class="title-icon"></fa-icon>
                My Account
            </h1>
            <p class="account-subtitle">Manage your subscription, boards, and account settings</p>
        </div>
    </div>

    <!-- Main Content Area -->
    <div class="account-main">
        <!-- Sidebar Navigation -->
        <aside class="account-sidebar">
            <nav class="sidebar-nav">
                <div class="nav-section">
                    <h3 class="nav-section-title">Account Settings</h3>
                    <ul class="nav-links">
                        <li class="nav-item">
                            <a 
                                class="nav-link" 
                                [routerLink]="['subscription']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <fa-icon [icon]="icons.faCreditCard" class="nav-icon"></fa-icon>
                                <span>Subscription</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a 
                                class="nav-link" 
                                [routerLink]="['boards']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <fa-icon [icon]="icons.faTableColumns" class="nav-icon"></fa-icon>
                                <span>My Boards</span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="isSuperAdmin">
                            <a 
                                class="nav-link" 
                                [routerLink]="['super-admin']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: false }"
                            >
                                <fa-icon [icon]="icons.faUserShield" class="nav-icon"></fa-icon>
                                <span>Super Admin</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </aside>

        <!-- Content Area -->
        <main class="account-content">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>